import { FC } from 'react';
import { PhoenixImage } from '@phoenix/core/frontend/shared/ui/assets/phoenix-image';
import { GlobalLink } from '@phoenix/core/frontend/shared/domain/static-content/static-content.static-generation.model';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { DynamicLinkWrapper } from '@phoenix/team-m/dashboard/frontend/shared/dynamic-link-wrapper';

interface TimberSportsTeaserProps {
  text: string;
  link: GlobalLink;
}

export const TimberSportsTeaser: FC<TimberSportsTeaserProps> = ({ text, link }) => {
  return (
    <DynamicLinkWrapper aria-label={text} hyperLink={link.url} allowReferrer={true} data-testid="timbersports-teaser">
      <article
        aria-label={text}
        className="mt-8 flex cursor-pointer flex-col overflow-hidden rounded-lg bg-secondary-deep text-primary-white tablet:h-[14.5rem] tablet:flex-row tablet:items-center desktop:h-[11.5rem]"
      >
        <div className="relative aspect-[16/9] h-full tabletOnly:aspect-[4/3]">
          <PhoenixImage
            src="timbersports-teaser.png"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            staticTags={['imagesDashboard']}
          />
        </div>
        <div className="flex w-full items-start justify-between gap-4 p-6">
          <div>
            <div className="relative w-52">
              <PhoenixImage src="timbersports-logo.svg" layout="responsive" staticTags={['imagesDashboard']} />
            </div>
            <p title={text} className="mt-8 line-clamp-4 stihl-text-body-default-reg desktop:line-clamp-2">
              {text}
            </p>
          </div>
          <div>
            <PhoenixIcon icon={getDesignSystemIcon('icon-external-link-16.svg')} />
          </div>
        </div>
      </article>
    </DynamicLinkWrapper>
  );
};
